module.exports = __webpack_public_path__ + "static/media/battery.c57343f0.png";